import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { EUserRoles } from '../../enums/EUserRoles';
import { PageRoutes } from '../../enums/enums';
import { useAppSelector } from '../../hooks/hooks';
import I18nButton from '../I18nButton';
import XDButton from '../buttons/XDButton';

interface mobileMenuProps {
  isMenuExpanded: boolean;
  onClose: () => void;
  mobileNavItems?: JSX.Element;
  hasNotifications?: boolean;
}

export default function MobileMenu({ isMenuExpanded, onClose, mobileNavItems, hasNotifications }: mobileMenuProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { dashboard } = useAppSelector((state) => state);

  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const roles = keycloak.tokenParsed?.realm_access?.roles ?? [];
  const showBell =
    roles.includes(EUserRoles.STAFF) ||
    roles.includes(EUserRoles.ADMIN) ||
    roles.includes(EUserRoles.PORTFOLIO_MANAGER);

  const handleClose = (ev: MouseEvent) => {
    const targetNode = ev.target as unknown as any;
    if ((ref.current?.contains(targetNode) as boolean) || !ref.current?.parentNode?.contains(targetNode)) {
      onClose();
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClose);
    return () => {
      window.removeEventListener('click', handleClose);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={
        'lg:hidden bg-teal-2 fixed flex ease-in-out duration-300 text-white shadow-lg w-full overflow-hidden -z-50'
      }
      style={{
        height: isMenuExpanded ? '100dvh' : 0,
        left: 0,
        top: 0,
        // opacity: isMenuExpanded ? 1 : 0,
        transitionProperty: isMenuExpanded ? 'height' : 'none'
      }}
    >
      <div
        className={'flex flex-col gap-1 w-full pb-8 px-2 text-2xl overflow-x-hidden'}
        style={{
          overflowY: isMenuExpanded ? 'auto' : 'hidden',
          height: isMenuExpanded ? '100dvh' : 0,
          paddingTop: dashboard.headerDimensions.h,
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'contain'
        }}
      >
        <div className={'text-white py-2 flex items-center justify-between'}>
          <I18nButton />

          {showBell && (
            <XDButton
              className={'aspect-square'}
              style={{ borderRadius: '100%' }}
              onClick={() => {
                onClose();
                navigate(`/${PageRoutes.NOTIFICATIONS_OUTLET}`);
              }}
            >
              <span className="relative block">
                <NotificationsNoneIcon style={{ fontSize: '100%', marginTop: '-5px' }} />
                {hasNotifications && <span className="absolute -top-0.5 right-0 w-2 h-2 bg-red-500 rounded-full" />}
              </span>
            </XDButton>
          )}
        </div>
        {mobileNavItems}
      </div>
    </div>
  );
}
